import { KeyboardEvent } from 'react';

/**
 * Wraps an activation handler so it also runs on Enter or Space, mirroring
 * native button activation for elements that stay non-native (role="button",
 * role="option" and similar). Space is prevented from scrolling the page.
 */
export function activateOnEnterOrSpace<T extends Element>(
  handler: (event: KeyboardEvent<T>) => void
): (event: KeyboardEvent<T>) => void {
  return (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handler(event);
    }
  };
}
